import { computed } from 'mobx';

export default class ItemModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.updateFromJson(item);
  }

  @computed get asJson() {
    return {
      id: +this.id,
      serial_no: this.serial_no,
      product_id: this.product_id,
      purchase_date: this.purchase_date,
      warranty_date: this.warranty_date,
      calibration_date: this.calibration_date,
      present_location: this.present_location,
      supplier_id: this.supplier_id,
      station_id: this.station_id,
      next_calibration_date: this.next_calibration_date,
      installation_date: this.installation_date
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.serial_no = json.serial_no;
    this.product_id = json.product_id;
    this.purchase_date = json.purchase_date.split('T')[0];
    this.warranty_date = json.warranty_date.split('T')[0];
    this.calibration_date = json.calibration_date.split('T')[0];
    this.next_calibration_date = json.next_calibration_date.split('T')[0];
    this.installation_date = json.installation_date.split('T')[0];
    this.present_location = json.present_location;
    this.supplier_id = json.supplier_id;
    this.station_id = json.station_id;
  }
}



// WEBPACK FOOTER //
// ./src/models/Inventory/InventoryItemModel.js